import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-delete-popup',
  templateUrl: './delete-popup.component.html',
  styleUrls: ['./delete-popup.component.scss']
})
export class DeletePopupComponent implements OnInit {
  @Input() name;
  @Input() modelRemove;
  @Input() fromLabBokkingTest: boolean = false;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  nameDelete : string;
  //public modelRemove: companyContactToRemove;
  constructor(public activeModel:NgbActiveModal,translate: TranslateService) { }

  ngOnInit(): void {
    console.log(this.modelRemove);
    this.nameDelete = this.name||'';
  }
  delete()
  {
    this.passEntry.emit(this.modelRemove);

  }
  close()
  {
    this.activeModel.close(this.modelRemove);

  }
}
